// extracted by mini-css-extract-plugin
export default {"ViewIcon":"styles_ViewIcon__2klHK"};